<template>
  <nav>
    <v-container>
      <v-row no-gutters>
        <v-col
          cols="12"
          md="7"
          lg="8"
          xl="9"
        >
          <div>{{ $t('targetGroupsAnalyticsTitle') }}</div>
        </v-col>
      </v-row>
      <v-divider />
      <v-row>
        <v-col
          cols="12"
          offset-md="6"
          md="6"
          offset-xl="8"
          xl="4"
        >
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateRangeText"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                persistent-hint
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="dates"
              range
            />
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="6"
          xl="4"
        >
          <v-card class="rounded-lg mx-auto">
            <v-card-subtitle>{{ $t('numPeople') }}</v-card-subtitle>
            <v-card-text>1234</v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="6"
          xl="4"
        >
          <v-card class="rounded-lg mx-auto">
            <v-card-subtitle>{{ $t('connectedActivities') }}</v-card-subtitle>
            <v-card-text>6</v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-divider />
      <v-row>
        <v-col
          cols="12"
          xl="4"
        >
          <v-card class="rounded-lg mx-auto">
            <v-card-subtitle>{{ $t('usersByTimeDiagramTitle') }}</v-card-subtitle>
            <GChart
              :settings="{ packages: ['corechart'] }"
              type="Histogram"
              :data="chartData"
              :options="chartOptions"
            />
          </v-card>
        </v-col>
        <v-col
          cols="12"
          xl="4"
        >
          <v-card class="rounded-lg mx-auto">
            <v-card-subtitle>{{ $t('sessionsByCountryDiagramTitle') }}</v-card-subtitle>
            <GChart
              :settings="{ packages: ['geochart'], mapsApiKey: 'AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY'}"
              type="GeoChart"
              :data="chartData2"
              :options="chartOptions2"
            />
            <GChart
              type="BarChart"
              :data="chartData2"
              :options="chartOptions2"
            />
          </v-card>
        </v-col>
        <v-col
          cols="12"
          xl="4"
        >
          <v-card class="rounded-lg mx-auto">
            <v-card-subtitle>{{ $t('sessionsByDeviceDiagramTitle') }}</v-card-subtitle>
            <GChart
              :settings="{ packages: ['corechart'] }"
              type="PieChart"
              :data="chartData3"
              :options="chartOptions3"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </nav>
</template>

<script>
import { GChart } from 'vue-google-charts'
  export default {
    components: {GChart},
    data: vm => ({
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      dates: [new Date().toISOString().substr(0, 10),  vm.getNextWeek()],
      chartData: [
        ['Day', 'Hour',"test"],
        ['Sun', 6, 2],
        ['Mon', 33, 6],
        ['Tue',29, 8],
        ['Wed', 10, 8],
        ['Thu', 30, 44],
        ['Fri', 15, 3],
        ['Sat', 8, 12]
      ],
      chartData2: [
        ['Country', 'Sessions by country'],
        ['Sweden', 93],
        ['United States', 3],
        ['North Macedonia', 3],
        ['India', 0],
        ['France', 0]
      ],
      chartData3: [
          ['Device', 'Sessions by device'],
          ['Mobile',  76.9],
          ['Desktop',  19.6],
          ['Tablet',  3.5]
      ],
      chartOptions: {
        colors: ['#006CFB','#6082fd','#899afe','#abb2ff','#c9cbff','#e4e5ff']
      },
      chartOptions2: {
        colors: ['#006CFB','#6082fd','#899afe','#abb2ff','#c9cbff','#e4e5ff']
      },
      chartOptions3: {
        pieHole: 0.4,
        colors: ['#006CFB','#6082fd','#899afe','#abb2ff','#c9cbff','#e4e5ff']
      }
    }),

    computed: {
      dateRangeText () {
        return this.dates.join(' - ')
      },
    },
    methods: {
      getNextWeek(){
        var newdate = new Date();
        newdate.setDate(newdate.getDate() + 7);

        const year = newdate.getFullYear()
        const month = `${newdate.getMonth() + 1}`.padStart(2, "0")
        const day = `${newdate.getDate()}`.padStart(2, "0")

        return [year, month, day].join("-") 
      }
    },
  }
</script>